<div class="kt-font-bold mb-3">Group Information</div>

<div *ngIf="mode === 'default'" class="alert alert-secondary">
    <p class="m-0">This is the provider default. Every player who is not in a group uses these limits. Its name and status cannot be changed, and it has no players.</p>
</div>

<form [formGroup]="form" class="kt-form">
    <div class="row">
        <div class="col-6 mb-4">
            <label class="control-label">Group Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="name" placeholder="e.g. High Roller" maxlength="150"
                [class.is-invalid]="invalid('name')">
            <div class="invalid-feedback">Group Name is required.</div>
        </div>
        <div class="col-6 mb-4">
            <label class="control-label">Sport Provider <span class="text-danger">*</span></label>
            <select class="form-control" formControlName="game_provider_id" [class.is-invalid]="invalid('game_provider_id')">
                <option [ngValue]="null" disabled>Select a sport provider</option>
                <option *ngFor="let p of providers" [ngValue]="p.game_provider_id">{{ p.code }}</option>
            </select>
            <small *ngIf="providers.length === 0" class="form-text text-danger">No settable sport provider in this brand.</small>
        </div>
        <div class="col-6 mb-4">
            <label class="control-label">Group Code</label>
            <input type="text" class="form-control" [value]="groupCode" placeholder="Generated on save" disabled>
            <small class="form-text text-muted">Generated from the provider and the name.</small>
        </div>
        <div class="col-6 mb-4">
            <label class="control-label">Status</label>
            <select class="form-control" formControlName="status">
                <option *ngFor="let s of statuses" [ngValue]="s.id">{{ s.name }}</option>
            </select>
        </div>
        <div class="col-12 mb-4">
            <label class="control-label">Remark</label>
            <input type="text" class="form-control" formControlName="remarks" placeholder="Internal note" maxlength="250">
        </div>
    </div>
</form>
